import styled from 'styled-components'

export const TagStyle = styled.div`
cursor: pointer;
height: 27px;
width: auto;
border-radius: 5px;
text-align: center;
background-color: coral;
padding: 5px;
font-size: 16px;
` 